export let DayToNum = (day) => {

  day = day.replace("״", "").replace("׳", "");
  // console.log(day)
  let num = '0';
  switch (day) {
    case 'א':
      num = '01';
      break;
    case 'ב':
      num = '02';
      break;
    case 'ג':
      num = '03';
      break;
    case 'ד':
      num = '04';
      break;
    case 'ה':
      num = '05';
      break;
    case 'ו':
      num = '06';
      break;
    case 'ז':
      num = '07';
      break;
    case 'ח':
      num = '08';
      break;
    case 'ט':
      num = '09';
      break;
    case 'י':
      num = '10';
      break;
    case 'יא':
      num = '11';
      break;
    case 'יב':
      num = '12';
      break;
    case 'יג':
      num = '13';
      break;
    case 'יד':
      num = '14';
      break;
    case 'טו':
      num = '15';
      break;
    case 'טז':
      num = '16';
      break;
    case 'יז':
      num = '17';
      break;
    case 'יח':
      num = '18';
      break;
    case 'יט':
      num = '19';
      break;
    case 'כ':
      num = '20';
      break;
    case 'כא':
      num = '21';
      break;
    case 'כב':
      num = '22';
      break;
    case 'כג':
      num = '23';
      break;
    case 'כד':
      num = '24';
      break;
    case 'כה':
      num = '25';
      break;
    case 'כו':
      num = '26';
      break;
    case 'כז':
      num = '27';
      break;
    case 'כח':
      num = '28';
      break;
    case 'כט':
      num = '29';
      break;
    case 'ל':
      num = '30';
      break;

    default:
      num = '00';
      break;
  }

  return num;

}

export let MonthToNum = (month) => {

  // console.log(month)
  month = month.replace("אָב", "אב")
                .replace("״", "")
                .replace("תַּמּוּז", "תמוז")
                .replace("׳", "");

                
  // console.log(month)
  let num = '0';
  switch (month) {
    case 'סיון':
      num = '09';
      break;

    case 'תמוז':
      num = '10';
      break;

    case 'אב':
      num = '11';
      break;


    default:
      num = '00';
      break;
  }

  return num;

}

export let YearToNum = (year) => {

  // console.log(year)

  let num = '0';
  switch (year) {
    case 'תשפה':
      num = '85';
      break;

    case 'תשפו':
      num = '86';
      break;
    default:
      num = '00';
      break;
  }

  return num;

}

export const ParashaToNum = (dayOffset) => {
  let num = '00';

  // console.log(dayOffset)
  const today = new Date();
  today.setDate(today.getDate() + dayOffset);
  
  // console.log(today)
  // let today = new Date();

  let year = today.getFullYear();
  let month = String(today.getMonth() + 1).padStart(2, '0'); // חודשים מ-0 עד 11
  let day = String(today.getDate()).padStart(2, '0');

  let fullDate = `${year}-${month}-${day}`;

  // console.log(today.getDay() + 1)

  if (fullDate <= '2025-06-28') {
    num = '0405/' + `${today.getDay() + 1}`; //קרח
  } else if (fullDate >= '2025-06-29' && fullDate <= '2025-07-05') {
    num = '0406/' + `${today.getDay() + 1}`; //חקת
  } else if (fullDate >= '2025-07-06' && fullDate <= '2025-07-12') {
    num = '0407/' + `${today.getDay() + 1}`; //בלק
  } else if (fullDate >= '2025-07-13' && fullDate <= '2025-07-19') {
    num = '0408/' + `${today.getDay() + 1}`; //פנחס
  } else if (fullDate >= '2025-07-20' && fullDate <= '2025-07-26') {
    num = '0409/' + `${today.getDay() + 1}`; //מטות-מסעי
  } else if (fullDate >= '2025-07-27' && fullDate <= '2025-08-02') {
    num = '0501/' + `${today.getDay() + 1}`; //דברים
  }

  // console.log(num)
  return num;
};



export function numberToHebrew(num) {
  const letters = [
    '', 'א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט',
    'י', 'יא', 'יב', 'יג', 'יד', 'טו', 'טז', 'יז', 'יח', 'יט',
    'כ', 'כא', 'כב', 'כג', 'כד', 'כה', 'כו', 'כז', 'כח', 'כט',
    'ל', 'לא', 'לב', 'לג', 'לד', 'לה', 'לו', 'לז', 'לח', 'לט',
    'מ', 'מא', 'מב', 'מג', 'מד', 'מה', 'מו', 'מז', 'מח', 'מט',
    'נ', 'נא', 'נב', 'נג', 'נד', 'נה', 'נו', 'נז', 'נח', 'נט',
    'ס', 'סא', 'סב', 'סג', 'סד', 'סה', 'סו', 'סז', 'סח', 'סט',
    'ע', 'עא', 'עב', 'עג', 'עד', 'עה', 'עו', 'עז', 'עח', 'עט',
    'פ', 'פא', 'פב', 'פג', 'פד', 'פה', 'פו', 'פז', 'פח', 'פט',
    'צ', 'צא', 'צב', 'צג', 'צד', 'צה', 'צו', 'צז', 'צח', 'צט',
    'ק', 'קא', 'קב', 'קג', 'קד', 'קה', 'קו', 'קז', 'קח', 'קט',
    'קי', 'קיא', 'קיב', 'קיג', 'קיד', 'קטו', 'קטז', 'קיז', 'קיח', 'קיט',
    'קכ', 'קכא', 'קכב', 'קכג', 'קכד', 'קכה', 'קכו', 'קכז', 'קכח', 'קכט',
    'קל', 'קלא', 'קלב', 'קלג', 'קלד', 'קלה', 'קלו', 'קלז', 'קלח', 'קלט',
    'קמ', 'קמא', 'קמב', 'קמג', 'קמד', 'קמה', 'קמו', 'קמז', 'קמח', 'קמט',
    'קנ'
  ];
  return letters[num] || num;
}

